/**
 * Curated list of sensitive/offensive English words used for
 * frontend content moderation of design-generation prompts.
 *
 * Categories covered:
 *   - Racial / ethnic slurs
 *   - Sexism / misogyny
 *   - Homophobia / transphobia
 *   - Religious hate
 *   - Violence / gore
 *   - Explicit sexual content
 *   - General profanity
 *   - Drug references
 *   - Politically inflammatory terms
 */

export const SENSITIVE_WORDS: string[] = [
  // ── Racial / ethnic slurs ──────────────────────────────────
  'nigger',
  'nigga',
  'coon',
  'darkie',
  'spic',
  'spick',
  'wetback',
  'beaner',
  'chink',
  'gook',
  'zipperhead',
  'slant',
  'towelhead',
  'raghead',
  'camel jockey',
  'sandnigger',
  'kike',
  'heeb',
  'redskin',
  'injun',
  'squaw',
  'wigger',
  'cracker',
  'honky',
  'gringo',
  'wop',
  'dago',
  'guinea',
  'polack',
  'kraut',
  'jap',
  'chinaman',
  'paki',
  'abo',
  'boong',
  'coonass',
  'halfbreed',

  // ── Sexism / misogyny ──────────────────────────────────────
  'bitch',
  'cunt',
  'whore',
  'slut',
  'hoe',
  'skank',
  'tramp',
  'thot',
  'twat',
  'feminazi',

  // ── Homophobia / transphobia ───────────────────────────────
  'faggot',
  'fag',
  'dyke',
  'queer',
  'homo',
  'tranny',
  'shemale',
  'ladyboy',
  'sodomite',
  'lesbo',

  // ── Religious hate ─────────────────────────────────────────
  'infidel',
  'heathen',
  'christkiller',
  'jihadist',
  'islamophobe',
  'zionist',

  // ── Violence / gore ────────────────────────────────────────
  'murder',
  'genocide',
  'massacre',
  'decapitate',
  'dismember',
  'mutilate',
  'torture',
  'lynch',
  'slaughter',
  'bloodbath',
  'execute',
  'assassinate',
  'stab',
  'behead',
  'strangle',
  'suffocate',
  'bombing',
  'terrorist',
  'terrorism',
  'ethnic cleansing',
  'holocaust',

  // ── Explicit sexual content ────────────────────────────────
  'porn',
  'pornography',
  'hentai',
  'gangbang',
  'bukkake',
  'orgasm',
  'blowjob',
  'handjob',
  'deepthroat',
  'anal',
  'dildo',
  'masturbate',
  'ejaculate',
  'cumshot',
  'fetish',
  'bondage',
  'erotic',
  'nude',
  'naked',
  'xxx',
  'nsfw',

  // ── General profanity ──────────────────────────────────────
  'fuck',
  'fucking',
  'motherfucker',
  'shit',
  'shitty',
  'bullshit',
  'asshole',
  'bastard',
  'damn',
  'dick',
  'cock',
  'pussy',
  'piss',
  'douche',
  'douchebag',
  'jackass',
  'dipshit',
  'retard',
  'retarded',

  // ── Drug references ────────────────────────────────────────
  'cocaine',
  'heroin',
  'meth',
  'methamphetamine',
  'crack',
  'ecstasy',
  'lsd',
  'fentanyl',
  'opium',
  'overdose',

  // ── Politically inflammatory ───────────────────────────────
  'nazi',
  'fascist',
  'supremacist',
  'white power',
  'aryan',
  'swastika',
  'apartheid',
  'segregation',
  'hate crime',
  'extremist',
  'propaganda',
  'radicalize'
]
